export interface SkeletonRowProps {
    rows?: (string | string[])[];
    height?: string;
}

const generateRandomRows = () => {
    const numberOfRows = Math.floor(Math.random() * 4) + 2;
    return Array.from({ length: numberOfRows }, () => 'w-full');
};

export const SkeletonRow = ({ rows = generateRandomRows(), height = 'h-6' }: SkeletonRowProps) => (
    <div className='space-y-4'>
        {rows.map((row, rowIndex) => (
            <div
                key={rowIndex}
                className='flex space-x-4'
            >
                {Array.isArray(row) ? (
                    row.map((widthClass, colIndex) => (
                        <div
                            key={colIndex}
                            className={`${widthClass} ${height} animate-pulse rounded bg-gray-200`}
                        />
                    ))
                ) : (
                    <div className={`${row} ${height} animate-pulse rounded bg-gray-200`} />
                )}
            </div>
        ))}
    </div>
);
